<template>
  <Flex
    v-if="currentData"
    justify="between"
  >
    <Flex
      direction="column"
      :gap="1.5"
    >
      <BaseText size="l">{{ currentData.label }}</BaseText>
      <BaseRadio
        v-model="selectedOption"
        :options="currentData.options"
        v-test="'cancel-flow-cancel-detail-reason'"
      />
    </Flex>
    <img
      v-if="$screen !== 's'"
      src="/img/cancel-subscription/person-asking-why.svg"
      :class="$style.image"
    >
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { useCancelSubscriptionData } from './data';
import type { CancelReasons } from './types';

const emit = defineEmits(['update:modelValue']);
const props = defineProps<{
  modelValue: CancelReasons;
}>();

const { allData } = useCancelSubscriptionData();
const currentData = ref(
  allData.find((item) => item.key === props.modelValue.main_reason),
);

const selectedOption = computed({
  get: () => currentData.value?.options[0].value || '',
  set: (value) => {
    updateValue(value);
  },
});

const updateValue = (value: string) => {
  emit('update:modelValue', {
    ...props.modelValue,
    [currentData.value?.key as keyof CancelReasons]: value,
  });
};

updateValue(selectedOption.value);
</script>

<style
  lang="scss"
  module
>
.image {
 height: 170px;
 width: auto;
}
</style>
